import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceHome } from "../features/shell/WorkspaceHome";

export const Route = createFileRoute("/w/$ws/")({ component: WorkspaceHome });
